module.exports = __webpack_public_path__ + "img/car-grey-vertical.b1466fa9.svg";